import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconDossier: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="dossier"><path d="M2 5.75C2 4.7835 2.7835 4 3.75 4H8V9.5H22V18.25C22 19.2165 21.2165 20 20.25 20H3.75C2.7835 20 2 19.2165 2 18.25V5.75Z" fill="currentColor"/><path d="M9.5 4H15V8H9.5V4Z" fill="currentColor"/><path d="M16.5 4H20.25C21.2165 4 22 4.7835 22 5.75V8H16.5V4Z" fill="currentColor"/></CentralIconBase>;
};

export default IconDossier;
